import { useTranslation } from '@chr/online-shared-ui-localizations';
import { DrawerSuccessSummary } from '@/common/components/side-drawer/DrawerSuccessSummary';
import { Box, Stack } from '@mui/material';
import { Typography } from '@chr/eds-react';
import { getDocumentTypeDisplayName } from '@/common/utilities/display-utilities';
import { PendingFile } from './UploadDocumentModal';

export interface UploadDocumentSuccessProps {
  pendingFileData: PendingFile;
  onAgain: () => void;
}

export const UploadDocumentSuccess = ({ pendingFileData, onAgain }: UploadDocumentSuccessProps) => {
  const translate = useTranslation();

  return (
    <DrawerSuccessSummary
      title={translate('File added successfully')}
      subTitle={translate('Your file has been added to our upload queue. It will be visible in the Documents tab shortly.')}
      againButtonText={translate('Add another document')}
      onAgain={onAgain}
    >
      <Stack spacing={2} overflow="clip">
        <Box>
          <Typography variant="subtitle200">{translate('Document')}</Typography>
          <Typography variant="body200">{pendingFileData.file?.name}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle200">{translate('Document Type')}</Typography>
          <Typography variant="body200">{translate(getDocumentTypeDisplayName(pendingFileData.documentType))}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle200">{translate('Shipment Number')}</Typography>
          <Typography variant="body200">{pendingFileData.shipmentId}</Typography>
        </Box>
      </Stack>
    </DrawerSuccessSummary>
  );
};
